import React from 'react';

const Minus = () => {
  return (
    <svg
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.3518 20.4638H6.35182C5.87443 20.4638 5.41659 20.2741 5.07903 19.9366C4.74146 19.599 4.55182 19.1412 4.55182 18.6638C4.55182 18.1864 4.74146 17.7285 5.07903 17.391C5.41659 17.0534 5.87443 16.8638 6.35182 16.8638H30.3518C30.8292 16.8638 31.287 17.0534 31.6246 17.391C31.9622 17.7285 32.1518 18.1864 32.1518 18.6638C32.1518 19.1412 31.9622 19.599 31.6246 19.9366C31.287 20.2741 30.8292 20.4638 30.3518 20.4638Z"
        fill="#494949"
      />
    </svg>
  );
};

export default Minus;
